import React, { useEffect, useState } from "react";
import { Table, PageHeader } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { agencyListingSaga } from "./saga";
import * as selectors from "./selectors";

const AgencyListing = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: agencyListingSaga });
  const dispatch = useDispatch();

  useEffect(() => {
    const query = `page=1&limit=10`;
    dispatch(actions.fetchAgencies({ query }));
    dispatch(actions.fetchTotalAgencies());
  }, [dispatch]);

  const agencies = useSelector(selectors.selectAgencies) || [];
  const loading = useSelector(selectors.selectLoading);
  const totalAgencyCount = useSelector(selectors.selectAgencyCount);
  const totalAgencies = useSelector(selectors.selectTotalAgencies);

  const [currentPage, setCurrentPage] = useState(1);

  const agencyData = agencies.map((agency) => ({
    id: agency._id,
    key: agency._id,
    name: agency.name,
    company: agency.company,
    businessType: agency.businessType,
    registeredAddress: agency.registeredAddress,
  }));

  const getAgencyFilters = () => {
    if (!totalAgencies) return [];
    const filter = [];
    totalAgencies.map((entity) => {
      const data = {
        text: entity.name,
        value: entity.name,
      };

      filter.push(data);
      return 0;
    });
    return filter;
  };

  const handleTablePagination = (pagination, filters, sorter) => {
    // setCurrentPage(pagination.current);
    // let query = `page=${pagination.current}&limit=10`;
    // if (filters.company) {
    //   query += `&companyName=${filters.company}`;
    // }
    // if (filters.businessType) {
    //   query += `&businessType=${filters.businessType}`;
    // }
    // dispatch(actions.fetchCompanies({ query }));
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      filters: getAgencyFilters(),
      filterSearch: true,
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
      filterSearch: true,
    },
    {
      title: "Business Type",
      dataIndex: "businessType",
      key: "businessType",
    },
    {
      title: "Registered Address",
      dataIndex: "registeredAddress",
      key: "registeredAddress",
    },
  ];

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Agency Listing"
        // extra={[
        //   <Button key="create" type="primary">
        //     <Link to={routes.backOffice.companies.new}>Create New Account</Link>
        //   </Button>,
        // ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <Table
          dataSource={agencyData}
          columns={columns}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: 10,
            total: totalAgencyCount,
            showSizeChanger: false,
            disabled: agencyData.length === 0 ? true : false,
          }}
          onChange={handleTablePagination}
        />
      </div>
    </div>
  );
};

export default AgencyListing;
